import { CrewMember, TimeEntryInput } from '@bechtel/types';
export interface AddCommentSidesheetProps {
  closeSidesheet: () => void;
  onSubmit: (values: AddCommentFormikState) => void;
  crewMember: CrewMember;
  timeEntryInput: TimeEntryInput;
}

export interface AddCommentFormikState {
  otherCommentDescription: string;
  commentId: string;
}
